<template>
    <AppFormValidator
        ref="validator"
        #default="{ errors }"
        :model="model"
        :rules="rules">
        <CForm>
            <CTextarea
                v-model="model.description"
                label="Краткое описание"
                placeholder="Укажите краткое описание (не более 255 символов)"
                :is-valid="errors.description && errors.description.isValid" />

            <CInput
                v-model="model.phone"
                label="Телефон"
                :is-valid="errors.phone && errors.phone.isValid" />
                <div class="mx-4"></div>
            <CInput
                label="Адрес для доставки"
                v-model="model.address"
                placeholder="Укажите адрес, которй будет показываться на странице доставки" />
            <div class="mx-4"></div>
            <div class="flex items-center">
                <CInput
                    v-model="model.open_at"
                    class="w-1/2"
                    label="Открывается в" />
                <div class="mx-4"></div>
                <CInput
                    v-model="model.close_at"
                    class="w-1/2"
                    label="Закрывается в" />
            </div>

            <div class="flex items-center">
                <CInput
                    v-model="model.min_price"
                    class="w-1/2"
                    label="Минимальный заказ"
                    :invalid-feedback="errors.min_price && errors.min_price.message"
                    :is-valid="errors.min_price && errors.min_price.isValid" />
                <div class="mx-4"></div>
                <CInput
                    v-model="model.min_price_pickup"
                    class="w-1/2"
                    label="Минимальная сумма для самовывоза"
                    :invalid-feedback="errors.min_price_pickup && errors.min_price_pickup.message"
                    :is-valid="errors.min_price_pickup && errors.min_price_pickup.isValid" />
            </div>

            <div class="flex items-center">
                <CInput
                    v-model="model.delay_time_hour"
                    class="w-1/2"
                    label="Время, необходимое на выполнение заказа (часы)"
                    :is-valid="errors.delay_time_hour && errors.delay_time_hour.isValid" />
                <div class="mx-4"></div>
                <CInput
                    v-model="model.delay_time"
                    class="w-1/2"
                    label="Время, необходимое на выполнение заказа (минуты)"
                    :is-valid="errors.delay_time && errors.delay_time.isValid" />
            </div>
            <div class="flex items-center">
                <CInput
                    v-model="model.delivery_time_hour"
                    class="w-1/2"
                    label="Время доставки (часы)"
                    :is-valid="errors.delivery_time_hour && errors.delivery_time_hour.isValid" />
                <div class="mx-4"></div>
                <CInput
                    v-model="model.delivery_time"
                    class="w-1/2"
                    label="Время доставки (минуты)"
                    :is-valid="errors.delivery_time && errors.delivery_time.isValid" />
            </div>

            <div class="flex items-center">
                <CInput
                    v-model="model.max_delivery_time_hour"
                    class="w-1/2"
                    label="Максимальное время доставки (часы)"
                    placeholder="Часы"
                />
                <div class="mx-4"></div>
                <CInput
                    v-model="model.max_delivery_time"
                    class="w-1/2"
                    label="Максимальное время доставки (минуты)"
                    placeholder="Минуты"
                />
            </div>

            <TimeSlotsUpdate :time-slots="timeSlots" @set-timeSlots="setTimeSlots" />

            <!-- <div class="flex"> -->

                <div class="w-1/2 mx-4"></div>
                <div class="w-1/2 mb-3 desktop-only-img">
                    Изображение сервиса (мобильное приложение)
                    <CInputFile
                        class="border"
                        custom
                        :placeholder="model.picture ? model.picture : 'Выберите изображение'"
                        :is-valid="errors.picture && errors.picture.isValid"
                        @change="uploadPicture" />
                </div>

                <div class="w-1/2 mb-3 desktop-only-img">
                    Изображение для доставки
                    <CInputFile
                        class="border"
                        custom
                        :placeholder="model.delivery_picture ? model.delivery_picture : 'Выберите изображение для доставки'"
                        :is-valid="errors.delivery_picture && errors.delivery_picture.isValid"
                        @change="uploadDeliveryPicture" />
                </div>
                <div class="mx-4"></div>
                <div class="w-1/2 mb-3 desktop-only-img">
                    Изображение для поиска
                    <CInputFile
                        class="border"
                        custom
                        :placeholder="model.square_picture ? model.square_picture : 'Выберите изображение для поиска'"
                        :is-valid="errors.square_picture && errors.square_picture.isValid"
                        @change="uploadSquarePicture" />
                </div>
                <div class="mx-4"></div>
                <div class="w-1/2 mb-3 desktop-only-img">
                    Изображение для декстопа (внутри сервиса)
                    <CInputFile
                        class="border"
                        custom
                        :placeholder="model.desktop_picture ? model.desktop_picture : 'Выберите изображение для декстопа'"
                        :is-valid="errors.desktop_picture && errors.desktop_picture.isValid"
                        @change="uploadDesktopPicture" />
                </div>
                <div class="mx-4"></div>
                <div class="w-1/2 mb-3 desktop-only-img">
                    Изображение для декстопа (список)
                    <CInputFile
                        class="border"
                        custom
                        :placeholder="model.desktop_picture_list ? model.desktop_picture_list : 'Выберите изображение для декстопа'"
                        :is-valid="errors.desktop_picture_list && errors.desktop_picture_list.isValid"
                        @change="uploadDesktopPictureInList" />
                </div>
                <div class="mx-4"></div>
                <div class="w-1/2 mb-3 desktop-only-img">
                    Изображение для популярного
                    <CInputFile
                        class="border"
                        custom
                        :placeholder="model.popular_picture ? model.popular_picture : 'Выберите изображение для популярпного'"
                        :is-valid="errors.popular_picture && errors.popular_picture.isValid"
                        @change="uploadPopularPicture" />
                </div>
                <div class="mx-4"></div>
            <!-- </div> -->
        </CForm>

        <div class="flex mt-4">
            <CButton color="primary" @click="submit">{{ submitButtonTitle }}</CButton>
        </div>

        <AppConfirmDialog
            ref="confirmDialog"
            title="Подтверждение"
            color="danger"
            text="Вы действительно хотите удалить запись? Это действие нельзя будет отменить."
            @confirm="confirmDelete" />
    </AppFormValidator>
</template>

<script>
    import to from 'await-to-js';
    import { morphism } from 'morphism';
    import { requiredRule, xssRegEx } from '@/utils/rules';

    import AppFormValidator from '@/components/AppFormValidator';
    import AppConfirmDialog from '@/components/AppConfirmDialog';
    import TimeSlotsUpdate from '@/components/TimeSlotsUpdate';
    import { translit } from '@/utils/translit';
    import moment from 'moment';

    export default {
        components: {
            AppFormValidator,
            AppConfirmDialog,
            TimeSlotsUpdate,
        },

        props: {
            entity: {
                type: Object,
                default: () => ({}),
            },
        },

        data: () => ({
            isPending: false,
            schedule: undefined,
            timeSlots: undefined,
            model: {},
            schema: {
                id: 'id',
                code: 'code',
                legal_entity: 'legal_entity',
                title: 'title',
                short_title: 'short_title',
                description: 'description',
                address: 'address',
                picture: 'picture',
                square_picture: 'square_picture',
                delivery_picture: 'delivery_picture',
                desktop_picture: 'desktop_picture',
                desktop_picture_list: 'desktop_picture_list',
                popular_picture: 'popular_picture',
                tower: 'tower',
                open_at: null,
                close_at: null,
                extended_schedule: 'extended_schedule',
                categories_page: 'categories_page',
                phone: 'phone',
                data_url: 'data_url',
                alias: 'alias',
                max_delivery_time_hour: 'max_delivery_time_hour',
                max_delivery_time: 'max_delivery_time',
                weight_limit: 'weight_limit',
                weight_limit_description: 'weight_limit_description',
                min_price_pickup: 'min_price_pickup',
                min_price: source =>
                    typeof source.min_price === 'number'
                        ? source.min_price.toString()
                        : undefined,
                delay_time_hour: source =>
                    typeof source.delay_time_hour === 'number'
                        ? source.delay_time_hour.toString()
                        : undefined,
                delay_time: source =>
                    typeof source.delay_time === 'number'
                        ? source.delay_time.toString()
                        : undefined,
                delivery_time_hour: source =>
                    typeof source.delivery_time_hour === 'number'
                        ? source.delivery_time_hour.toString()
                        : undefined,
                delivery_time: source =>
                    typeof source.delivery_time === 'number'
                        ? source.delivery_time.toString()
                        : undefined,
                position: source => (source.position ? source.position : 1),
                enabled: source =>
                    typeof source.enabled === 'boolean' ? source.enabled : false,
            },
            rules: {
                title: [requiredRule],
                code: [requiredRule],
                description: [requiredRule],
                picture: [requiredRule],
                phone: [requiredRule],
                delay_time: [
                    {
                        type: 'string',
                        pattern: /^[0-9]*$/,
                        message: 'Укажите в цифрах',
                    },
                ],
                delay_time_hour: [
                    {
                        type: 'string',
                        pattern: /^[0-9]*$/,
                        message: 'Укажите в цифрах',
                    },
                ],
                delivery_time: [
                    {
                        type: 'string',
                        pattern: /^[0-9]*$/,
                        message: 'Укажите в цифрах',
                    },
                ],
                delivery_time_hour: [
                    {
                        type: 'string',
                        pattern: /^[0-9]*$/,
                        message: 'Укажите в цифрах',
                    },
                ],
                min_price: [
                    {
                        type: 'string',
                        pattern: /^[1-9]{1}[0-9]*$/,
                        message: 'Укажите в цифрах или оставьте поле пустым',
                    },
                ],
            },
            towers: [],
        }),
        
        computed: {
            submitButtonTitle() {
                return typeof this.entity.id === 'number' ? 'Сохранить' : 'Создать';
            },
            adminOnly() {
                return !JSON.parse(localStorage.getItem('settings'))
                    .is_business_admin;
            },
            computedCode() {
                if (!this.entity.code) {
                    // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                    this.model.code = translit(
                        this.model.title ? this.model.title : ''
                    );
                }
                return this.model.code;
            },
        },

        created() {
            this.setModel();
        },

        mounted() {
            const id = this.$route.params.id;
            this.axios
                .get(`/grocers/${id}`)
                .then(resp => {
                    if(resp.data?.timeSlots?.length != 0) {
                        this.timeSlots = resp.data.timeSlots;
                    }
                })
                .catch(err => {
                    console.log('Ошибка загрузки данных');
                });

            if (!this.towers.length) {
                const towers = [{ value: null, label: 'Башня...' }];
                this.axios
                    .get('/address')
                    .then(({ data }) => {
                        data.forEach(tower => {
                            towers.push({ value: tower.id, label: tower.name });
                        });
                    });
                this.towers = towers;
            }
        },

        methods: {
            setSchedule(schedule) {
                this.schedule = schedule;
            },

            setTimeSlots(timeSlots) {
                this.timeSlots = timeSlots;
            },

            setModel() {
                this.model = morphism(this.schema, this.entity);
                if (!this.entity.schedule) {
                    this.entity.schedule = [];
                }
                this.setSchedule(this.entity.schedule);
                
                if (!this.entity.timeSlots) {
                    this.entity.timeSlots = [];
                }
                this.setTimeSlots(this.entity.timeSlots);
            },

            async uploadPicture(FileList) {
                const form = new FormData();
                form.append('file', FileList[0]);

                const [err, result] = await to(
                    this.axios.post('/files/upload', form)
                );

                if (err) {
                    this.$root.$emit('showError', 'Ошибка. Не удалось загрузить картинку. ' + err);
                }

                this.model.picture = result.data.filename;
            },

            async uploadSquarePicture(FileList) {
                const form = new FormData();
                form.append('file', FileList[0]);

                const [err, result] = await to(
                    this.axios.post('/files/upload', form)
                );

                if (err) {
                    this.$root.$emit('showError', 'Ошибка. Не удалось загрузить картинку. ' + err);
                }

                this.model.square_picture = result.data.filename;
            },

            async uploadDesktopPicture(FileList) {
                const form = new FormData();
                form.append('file', FileList[0]);

                const [err, result] = await to(
                    this.axios.post('/files/upload', form)
                );

                if (err) {
                    this.$root.$emit('showError', 'Ошибка. Не удалось загрузить картинку. ' + err);
                }

                this.model.desktop_picture = result.data.filename;
            },
            async uploadDesktopPictureInList(FileList) {
                const form = new FormData();
                form.append('file', FileList[0]);

                const [err, result] = await to(
                    this.axios.post('/files/upload', form)
                );

                if (err) {
                    alert('Ошибка. Не удалось загрузить картинку.');
                }

                this.model.desktop_picture_list = result.data.filename;
            },
            async uploadPopularPicture(FileList) {
                const form = new FormData();
                form.append('file', FileList[0]);

                const [err, result] = await to(
                    this.axios.post('/files/upload', form)
                );
                
                if (err) {
                    alert('Ошибка. Не удалось загрузить картинку.');
                }

                this.model.popular_picture = result.data.filename;
            },

            async uploadDeliveryPicture(FileList) {
                const form = new FormData();
                form.append('file', FileList[0]);

                const [err, result] = await to(
                    this.axios.post('/files/upload', form)
                );

                if (err) {
                    this.$root.$emit('showError', 'Ошибка. Не удалось загрузить картинку. ' + err);
                }

                this.model.delivery_picture = result.data.filename;
            },

            checkSlots(slots) {
                for (let i = 0; i < slots.length; i++) {
                    const checkStart = moment(slots[i].start_at, 'HH:mm');
                    const checkEnd = moment(slots[i].end_at, 'HH:mm');
                    const condidates = slots.filter(filterSlot => 
                        moment(filterSlot.start_at, 'HH:mm').isSameOrAfter(checkStart) &&
                        moment(filterSlot.end_at, 'HH:mm').isSameOrBefore(checkEnd)
                    );

                    if (condidates.length > 1) {
                        return `Слот на время с ${condidates[0].start_at} или до ${condidates[0].end_at} уже есть.`
                    }
                }
                return '';
            },

            async submit() {
                const [error] = await to(this.$refs.validator.validate());

                if (error) {
                    return false;
                }

                const { id, ...payload } = this.model;
                if (xssRegEx.test(payload.description)) {
                    this.$root.$emit('showError', 'Описание содержит недопустимые символы.')
                    return
                }

                payload.timeSlots = this.timeSlots;

                const noneDayOfWeek = [];
                for (const slot of payload.timeSlots) {
                    if (slot.day_of_week === null) {
                        noneDayOfWeek.push(slot)
                    }
                }
                const checkSlots = this.checkSlots(noneDayOfWeek);
                if (checkSlots) {
                    this.$root.$emit('showError', checkSlots);
                    return;
                }

                payload.extended_schedule = !!payload.extended_schedule;
                payload.categories_page = !!payload.categories_page;
                payload.position = parseInt(payload.position);
                payload.delay_time = payload.delay_time
                    ? parseInt(payload.delay_time)
                    : 0;
                payload.delay_time_hour = payload.delay_time_hour
                    ? parseInt(payload.delay_time_hour)
                    : 0;
                payload.delivery_time = payload.delivery_time
                    ? parseInt(payload.delivery_time)
                    : 0;
                payload.delivery_time_hour = payload.delivery_time_hour
                    ? parseInt(payload.delivery_time_hour)
                    : 0;
                payload.min_price = payload.min_price
                    ? parseInt(payload.min_price)
                    : 0;
                payload.min_price_pickup = payload.min_price_pickup ? parseInt(payload.min_price_pickup) : null,
                payload.data_url = payload.data_url ? payload.data_url : '';
                payload.schedule = this.schedule;
                payload.max_delivery_time = +payload.max_delivery_time ? +payload.max_delivery_time : null;
                payload.max_delivery_time_hour = +payload.max_delivery_time_hour ? +payload.max_delivery_time_hour : null;
                payload.weight_limit = +payload.weight_limit ? +payload.weight_limit : null;
                if (!payload.open_at) {
                    payload.open_at = '0';
                }
                if (!payload.close_at) {
                    payload.close_at = '0';
                }
                if (typeof id === 'number') {
                    const [err] = await to(
                        this.axios.put(`/grocers/${id}`, payload)
                    );
                    if (err) {
                        return this.$root.$emit('showError', 'Ошибка. Не удалось сохранить запись. ' + err);
                    }
                } else {
                    const [err] = await to(this.axios.post('/grocers', payload));
                    if (err) {
                        return this.$root.$emit('showError', 'Ошибка. Не удалось создать новую запись. ' + err);
                    }
                }

                this.$emit('success');
            },

            async confirmDelete() {
                if (!this.model.id) {
                    return false;
                }

                const [error] = await to(
                    this.axios.delete(`/grocers/${this.model.id}`)
                );

                if (error) {
                    this.$root.$emit('showError', 'Ошибка удаления. ' + error);
                }

                this.$emit('deleted');
            },
        },
    };
</script>
<style scoped lang="scss">
@media (max-width: 767px) {
    .desktop-only-img {
        width: 100% !important;
    }
}

</style>
